var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupportDocs = function SvgSupportDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M46 20H22a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h24a6 6 0 0 0 6-6V26a6 6 0 0 0-6-6m-24-2a8 8 0 0 0-8 8v36a8 8 0 0 0 8 8h24a8 8 0 0 0 8-8V26a8 8 0 0 0-8-8z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M30 12h24a6 6 0 0 1 6 6v36a6 6 0 0 1-6 6v2a8 8 0 0 0 8-8V18a8 8 0 0 0-8-8H30a8 8 0 0 0-8 8h2a6 6 0 0 1 6-6",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M34.84 50.76v4.76q0 .48-.4.48H33q-.4 0-.4-.48v-4.76q0-.44.4-.44h1.44q.4 0 .4.44m-.12-5v1.44q0 .48-.4.48H33.2q-.44 0-.44-.48v-1.32q0-1.64.44-2.52.48-.92 1.88-2.12L36.52 40q1.56-1.32 1.56-2.96v-1.12q0-3.84-3.8-3.84h-1.64q-3.76 0-3.76 3.84v1.68q0 .48-.44.48h-1.16q-.44 0-.44-.48v-1.72q0-2.6 1.52-4.08t4.12-1.48h1.96q2.6 0 4.12 1.48t1.52 4.08v1.24q0 2.16-1.92 3.72l-1.84 1.56q-1.08.88-1.36 1.52-.24.64-.24 1.84"
  })));
};
export default SvgSupportDocs;